import "./comment-list.css";
import swal from "sweetalert";
import { AiOutlineEdit } from "react-icons/ai";
import { BsFillTrashFill } from "react-icons/bs";
import { useState } from "react";
import UpdateCommentModal from "./UpdateCommentModal";
import Moment from "react-moment";
import { useSelector, useDispatch } from "react-redux";
import { deleteComment } from "../../redux/apiCalls/commentApiCalls";

const CommentList = ({ comments }) => {
  
  const [updateComment, setUpdateComment] = useState(false);
  const [commentForUpdate, setCommentForUpdate] = useState(null);

  const user = useSelector((state) => state.auth.user);
  const dispatch = useDispatch();

  //Update comment handler
  const updateCommentHandler = (comment) => {
    setCommentForUpdate(comment);
    setUpdateComment(true);
  };
  // Delete Comment Handler
  const deleteCommentHandler = (commentId) => {
    swal({
      title: "هل تريد فعلا حذف التعليق ؟",
      text: "لن تستطيع استعادة التعليق ثانية",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then((isOk) => {
      if (isOk) {
        dispatch(deleteComment(commentId));
      }
    });
  };

  return (
    <div className="comment-list">
      <h4 className="comment-list-count"> {comments?.length} تعليق</h4>
      {comments?.map((comment) => (
        <div key={comment?._id} className="comment-item">
          <div className="comment-item-info">
            <div className="comment-item-user-info">
              <img className="comment-item-user-photo" src={user?.profilePhoto?.url} alt="" />
              <span className="comment-item-username">{comment?.username?.substr(0,15)}</span>
              <div className="comment-item-time">
              <Moment ago fromNow>
                {comment?.createdAt}
              </Moment>
              <span>ago</span>
            </div>
            </div>
            <p className="comment-item-text">{comment?.text}</p>
          </div>
          {user?._id === comment?.user && (
            <div className="comment-item-icon-wrapper">
              <AiOutlineEdit
                className="commnet-item-icon"
                color="blue"
                onClick={() => updateCommentHandler(comment)}
              />
              <BsFillTrashFill
                className="commnet-item-icon"
                color="red"
                onClick={() => deleteCommentHandler(comment?._id)}
              />
            </div>
          )}
        </div>
      ))}
      {updateComment && (
        <UpdateCommentModal
          commentForUpdate={commentForUpdate}
          setUpdateComment={setUpdateComment}
        />
      )}
    </div>
  );
};

export default CommentList;
